import './sentry'

import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import "regenerator-runtime";

import './theme/theme.scss';
import './i18n';
import '@aws-amplify/ui-react/styles.css';
import './styles/satoshi.css';

import App from './components/App/App';
import reportWebVitals from './reportWebVitals';
import SvgIcons from './assets/svgIcons';
import { AuthProvider } from './context/AuthContext';
import { CookiesProvider } from 'react-cookie';
import { AiProvider } from './context/AiContext';
import React from 'react';
import { ConfirmActionProvider } from './hooks/useConfirmAction';
const root = ReactDOM.createRoot(document.getElementById('root')!);
const queryClient = new QueryClient();

root.render(
	<>
		<SvgIcons />
		{/* <React.StrictMode> */}
		<Router>
			<QueryClientProvider client={queryClient}>
				<AuthProvider>
					{process.env.REACT_APP_QUICKO_ENABLED === '1' ? (
						<AiProvider>
							<CookiesProvider defaultSetOptions={{ path: '/' }}>
								<ConfirmActionProvider>
									<App />
								</ConfirmActionProvider>
							</CookiesProvider>
						</AiProvider>
					) : (
						<CookiesProvider defaultSetOptions={{ path: '/' }}>
							<ConfirmActionProvider>
								<App />
							</ConfirmActionProvider>
						</CookiesProvider>
					)}
				</AuthProvider>
			</QueryClientProvider>

		</Router >
		{/* </React.StrictMode> */}
	</>
);

reportWebVitals();

